module.exports = __webpack_public_path__ + "img/pucko_logo.ea5e8ef9.svg";